import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'ticketTemplates';

// Action Types
export const types = {
  GET_TICKET_TEMPLATES: createAsyncTypes(`${KEY}/GET_TICKET_TEMPLATES`),
  CREATE_TICKET_TEMPLATE: createAsyncTypes(`${KEY}/CREATE_TICKET_TEMPLATE`),
  UPDATE_TICKET_TEMPLATE: createAsyncTypes(`${KEY}/UPDATE_TICKET_TEMPLATE`),
  DELETE_TICKET_TEMPLATE: createAsyncTypes(`${KEY}/DELETE_TICKET_TEMPLATE`),
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  RESET_ERROR: `${KEY}/RESET_ERROR`
};

export interface TicketTemplate {
  id: string;
  type: string;
  name: string;
  template: string;
  createdAt: string;
  updatedAt: string;
}

export interface TicketTemplatesState {
  readonly ticketTemplates: TicketTemplate[];
  readonly createdTicketTemplate: TicketTemplate | null;
  readonly action: {
    readonly pending: boolean;
    readonly success: boolean;
    readonly error: string | null;
  };
}

export interface CreateTicketTemplatePayload {
  type: string;
  template: string;
}

export interface GetTicketTemplatesRequest {
  type: typeof types.GET_TICKET_TEMPLATES.REQUEST;
}

export interface GetTicketTemplatesPending {
  type: typeof types.GET_TICKET_TEMPLATES.PENDING;
  payload: boolean;
}

export interface GetTicketTemplatesSuccess {
  type: typeof types.GET_TICKET_TEMPLATES.SUCCESS;
  payload: TicketTemplate[];
}

export interface GetTicketTemplatesError {
  type: typeof types.GET_TICKET_TEMPLATES.ERROR;
  payload: string;
}

export interface CreateTicketTemplateRequest {
  type: typeof types.CREATE_TICKET_TEMPLATE.REQUEST;
  payload: CreateTicketTemplatePayload;
}

export interface CreateTicketTemplatePending {
  type: typeof types.CREATE_TICKET_TEMPLATE.PENDING;
  payload: boolean;
}

export interface CreateTicketTemplateSuccess {
  type: typeof types.CREATE_TICKET_TEMPLATE.SUCCESS;
  payload: TicketTemplate;
}

export interface CreateTicketTemplateError {
  type: typeof types.CREATE_TICKET_TEMPLATE.ERROR;
  payload: string;
}

export type UpdateTicketTemplatePayload = Partial<TicketTemplate> & { id: string };

export interface UpdateTicketTemplateRequest {
  type: typeof types.UPDATE_TICKET_TEMPLATE.REQUEST;
  payload: UpdateTicketTemplatePayload;
}

export interface UpdateTicketTemplatePending {
  type: typeof types.UPDATE_TICKET_TEMPLATE.PENDING;
  payload: boolean;
}

export interface UpdateTicketTemplateSuccess {
  type: typeof types.UPDATE_TICKET_TEMPLATE.SUCCESS;
  payload: TicketTemplate;
}

export interface UpdateTicketTemplateError {
  type: typeof types.UPDATE_TICKET_TEMPLATE.ERROR;
  payload: string;
}

export interface DeleteTicketTemplateRequest {
  type: typeof types.DELETE_TICKET_TEMPLATE.REQUEST;
  payload: { id: string };
}

export interface DeleteTicketTemplatePending {
  type: typeof types.DELETE_TICKET_TEMPLATE.PENDING;
  payload: boolean;
}

export interface DeleteTicketTemplateSuccess {
  type: typeof types.DELETE_TICKET_TEMPLATE.SUCCESS;
}

export interface DeleteTicketTemplateError {
  type: typeof types.DELETE_TICKET_TEMPLATE.ERROR;
  payload: string;
}

export interface ResetAction {
  type: typeof types.RESET_ACTION;
}

export interface ResetError {
  type: typeof types.RESET_ERROR;
}

export type TicketTemplatesActionTypes =
  | GetTicketTemplatesRequest
  | GetTicketTemplatesPending
  | GetTicketTemplatesSuccess
  | GetTicketTemplatesError
  | UpdateTicketTemplateRequest
  | UpdateTicketTemplatePending
  | UpdateTicketTemplateSuccess
  | UpdateTicketTemplateError
  | CreateTicketTemplateRequest
  | CreateTicketTemplatePending
  | CreateTicketTemplateSuccess
  | CreateTicketTemplateError
  | DeleteTicketTemplateRequest
  | DeleteTicketTemplatePending
  | DeleteTicketTemplateSuccess
  | DeleteTicketTemplateError
  | ResetAction
  | ResetError;
